import { SessionStateApiClient } from '@/api/session-state';
import { IdentifierType } from '@/api/types';
import { useHandleErrors } from '@/common/utils/useHandleErrors';
import { FinalizeOptions, useLoginFinalize } from '@/hooks/useLoginFinalize';
import { EmailRoutes } from '@/Routes';
import { useSessionStore } from '@/store/session';
import { useSignInStore } from '@/store/signInStore';
import { useRouter } from 'next/navigation';

export const useHandleSessionState = () => {
  const router = useRouter();
  const handleLoginFinalize = useLoginFinalize();
  const handleErrors = useHandleErrors();
  const isEmailAllowed = useSessionStore((s) =>
    s.allowedIdentifiers.includes(IdentifierType.EMAIL),
  );

  return async (elementId: string, options?: FinalizeOptions) => {
    try {
      if (isEmailAllowed) {
        const session = useSignInStore.getState().session;

        const isEmailIdentifier =
          session.identifierType === IdentifierType.EMAIL;
        const resp = isEmailIdentifier
          ? { email: session.identifier }
          : await SessionStateApiClient.me();

        if (!resp.email) {
          router.push(EmailRoutes.EMAIL_ENTRY);
          return;
        }
      }

      await handleLoginFinalize(elementId, options);
    } catch (err) {
      handleErrors(err);
    }
  };
};
